import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export default function NotFound() {
  return (
    <div className="flex flex-col items-start gap-3 py-16">
      <p className="text-xs font-medium uppercase tracking-wide text-[var(--muted-foreground)]">
        404
      </p>
      <h1 className="text-lg font-semibold text-[var(--foreground)]">Seite nicht gefunden</h1>
      <p className="max-w-prose text-sm text-[var(--muted-foreground)]">
        Diese Adresse gibt es nicht (mehr). Prüfe den Link oder kehr zu den Freigaben zurück.
      </p>
      <Link
        to="/"
        className="mt-1 inline-flex items-center gap-1.5 rounded-md border border-[var(--border)] px-3 py-1.5 text-xs font-medium text-[var(--foreground)] hover:bg-[var(--muted)]"
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Zu den Freigaben
      </Link>
    </div>
  )
}
